export default "__VITE_ASSET__Csij5kT8__ 100w";